var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VCard',[_c('VCardText',[_c('VSheet',[_c('VSparkline',{attrs:{"value":_vm.item.values,"labels":_vm.item.labels}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }